import React from 'react';
import styles from './actionsTab.module.css';
import WorkflowTriggers from './triggers/triggers';
import WorkflowConditions from './conditions/conditions';
import AccountSettingsTab from '../../../../../layouts/accountSettingsLayout/accountSettingsTab';
import WorkflowActions from './actions/actions';

const WorkflowActionsPage = ({ isEditing }: { isEditing: boolean }) => {
  return (
    <>
      <AccountSettingsTab>
        <main className={styles._workflow_page__container}>
          <WorkflowTriggers />
        </main>
      </AccountSettingsTab>
      <WorkflowConditions isEditing={isEditing} />
      <WorkflowActions />
    </>
  );
};

export default WorkflowActionsPage;
